import { render, staticRenderFns } from "./PreferenceModal.vue?vue&type=template&id=f715c064"
import script from "./PreferenceModal.ts?vue&type=script&lang=ts&external"
export * from "./PreferenceModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports